import { Component, forwardRef } from '@angular/core';
import {
	MapOptions,
	tileLayer,
	LatLng,
	latLng,
	Marker,
	marker,
	icon,
} from 'leaflet';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { every } from 'lodash';

@Component({
	selector: 'rpshared-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => MapComponent),
			multi: true,
		},
	],
})
export class MapComponent implements ControlValueAccessor {
	marker: Marker;
	isDisabled = false;

	kansas = latLng(38.642763, -98.327818);

	baseOptions: MapOptions = {
		layers: [
			tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
			}),
		],
		zoom: 3,
		center: this.kansas,
	};

	onTouched: () => void = () => {};
	onChanged: (value: {
		latitude: number;
		longitude: number;
	}) => void = () => {};

	// model --> view
	writeValue(value: { latitude: number; longitude: number }): void {
		if (value && every(value)) {
			this.addMarker(
				latLng({ lat: value.latitude, lng: value.longitude }),
				{ emitEvent: false }
			);
		}
	}

	// view --> model
	registerOnChange(
		fn: (value: { latitude: number; longitude: number }) => void
	) {
		this.onChanged = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouched = fn;
	}

	setDisabledState(isDisabled: boolean) {
		this.isDisabled = isDisabled;
	}

	addMarker = (latlng: LatLng, opts?: { emitEvent: boolean }) => {
		this.marker = marker(latlng, {
			icon: icon({
				iconSize: [25, 41],
				iconAnchor: [13, 41],
				iconUrl: 'src/shared/assets/marker-icon.png',
				shadowUrl: 'src/shared/assets/marker-shadow.png',
			}),
			draggable: true,
		});
		this.marker.on('dragend', (val) => {
			latlng = val.target.getLatLng();
			this.addMarker(latlng);
		});
		this.baseOptions.center = latlng;
		this.baseOptions.zoom = 8;
		if (!opts || opts.emitEvent) {
			this.onChanged({ latitude: latlng.lat, longitude: latlng.lng });
		}
	};
}
